<template>
  <form autocomplete="off">
    <h1 class="page-title pb-30">USER ROLE</h1>

    <div class="tabs">
      <tab title="Define Role" number="1" :active="true">
        <div class="columns is-multiline">
          <div class="column field is-4">
            <label class="label">Role</label>
            <div class="control">
              <div class="select">
                <select v-model="model.roleID" @change="setDefaultPermissions">
                  <option v-for="r in roles" :key="r.roleID" :value="r.roleID">
                    {{ r.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="column field is-4">
            <label class="label">Access to</label>
            <div class="control">
              <div class="select">
                <select v-model="model.groupID">
                  <option
                    v-for="r in $store.getters['groups/flatTree'](model.roleID)"
                    :key="r.groupID"
                    :value="r.groupID"
                    :disabled="r.disabled"
                    v-html="r.name"
                  >
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </tab>

      <tab
        title="Customize Permissions"
        number="2"
        :active="permissionsTab"
        @click:header="permissionsTab = !permissionsTab"
      >
        <div class="columns is-multiline">
          <div
            v-for="(permission, index) in permissions"
            :key="index"
            class="column is-4 field notifications"
          >
            <app-checkbox
              v-model="rolePermissions[index]"
              class="large"
              :value="permission.permissionID"
              @change="togglePermission(permission, index)"
            >
              {{ permission.name }}
            </app-checkbox>
          </div>
        </div>
      </tab>
    </div>
    <div class="has-text-centered mt-30">
      <button class="button is-primary" @click.prevent="saveRole">
        Save
      </button>
    </div>
  </form>
</template>

<script>
import _ from 'lodash';
import Form from './Form.js';
//import { ValidationProvider } from 'vee-validate';
import AppCheckbox from '@/components/AppCheckbox.vue';
import '@/validation.js';
import Tab from '@/components/tabs/Tab';

export default {
  name: 'RoleForm',
  components: {
    Tab,
    AppCheckbox
  },
  extends: Form,
  props: {
    settings: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null
    },
    userId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      permissionsTab: true,
      rolePermissions: []
    };
  },
  computed: {
    permissions() {
      return this.$store.getters['permissions/list'];
    },
    roles() {
      const roleID = this.$store.getters.userRoleId;

      return this.$store.state.roles.filter(item => {
        return item.roleID > roleID || roleID == 10;
      });
    }
  },
  watch: {
    value() {
      this.setPermissions();
    }
  },
  methods: {
    togglePermission(permission, index) {
      //console.log(permission.permissionID, index, this.rolePermissions[index]);
    },
    setPermissions() {
      this.rolePermissions = [];
      this.$store.state.roles.map(item => {
        if (item.roleID == this.model.roleID) {
          this.rolePermissions.map((role, index) => {
            this.rolePermissions[index] = false;
          });

          if (this.model.userRoleID) {
            this.model.permissions.map(permission => {
              const idx = _.findIndex(this.permissions, {
                permissionID: permission.permissionID
              });
              this.rolePermissions[idx] = true;
            });
          } else {
            item.defaultPermissions.map(permission => {
              const idx = _.findIndex(this.permissions, {
                permissionID: permission.permissionID
              });
              this.rolePermissions[idx] = true;
            });
          }
        }
      });
    },
    setDefaultPermissions() {
      console.log('setDefaultPermissions');
      this.$store.state.roles.map(item => {
        if (item.roleID == this.model.roleID) {
          this.rolePermissions.map((role, index) => {
            this.rolePermissions[index] = false;
          });

          item.defaultPermissions.map(permission => {
            const idx = _.findIndex(this.permissions, {
              permissionID: permission.permissionID
            });
            this.rolePermissions[idx] = true;
          });
        }
      });
    },
    saveRole() {
      const group = this.$store.getters['groups/byId'](this.model.groupID);
      this.model.organizationID = group.organizationID;

      this.model.applyDefaultPermissions = false;
      this.model.permissions = [];
      this.rolePermissions.map((item, index) => {
        if (this.rolePermissions[index]) {
          this.model.permissions.push({
            permissionID: this.permissions[index].permissionID,
            isAllowed: true,
            groupID: this.model.groupID
          });
        }
      });

      let path = `Users/${this.userId}/Roles`;
      let method = 'post';
      const args = this.model;

      if (this.value.userRoleID) {
        path = `Users/${this.userId}/Roles/${this.value.userRoleID}`;
        method = 'put';
      }

      this.axiosRequest(method, path, args)
        .then(response => {
          //console.log(response.data);

          if (this.value.userRoleID) this.$emit('updated', response.data);
          else this.$emit('created', response.data);

          this.showSuccessMessage('User role saved');
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
